const appInfo = {
  title: "Uyguna Kirala",
};
export default appInfo;
